import { z } from "zod/v4";

const NistRequiredSchema = z.object({
  nist_required: z.literal(true),
  nist_completion: z
    .string()
    .length(10, "Please enter an Estimated Completion Date"),
  // This will be a date that comes in the format of YYYY-MM-DD (10 CHARS)
  // might want to look at z.date() in the future
});

const NistNotRequiredSchema = z.object({
  nist_required: z.literal(false),
  nist_completion: z.string().length(0),
  // If no date is selected we will receive an empty string
});

export const NistSchema = z.discriminatedUnion("nist_required", [
  NistRequiredSchema,
  NistNotRequiredSchema,
]);

export const NistDraftSchema = z.object({
  nist_required: z.boolean(),
  nist_completion: z.string(),
});
